import { Switch } from '@thanx/uikit/switch'
import { withFormsy } from 'formsy-react'
import { Button } from 'react-bootstrap'

import { PillInput } from 'components/Form/PillInput'
import { buildTranslate } from 'locales'
import ModifierPopover, {
  ModifierPopoverVariant,
} from './OnlineRedemptionCard/ModifierPopover'

type ModifierOrProductInputProps = {
  name: string
  label: string
  secondaryText?: string
  tertiaryText?: string
  // Rendered under the field, above the in-store validation note
  noteText?: string
  value?: string[]
  className?: string
  disabled?: boolean
  placeholder?: string
  setValue: (value: string[]) => void
  toggleVisibility?: (visible: boolean) => void
  hideLabel?: string
  // Replaces the default hide (clear and collapse) with a custom action
  onHide?: () => void
  shouldDisplayModifierPopover?: boolean
  popoverVariant?: ModifierPopoverVariant
  shouldDisplayInstoreValidationNote?: boolean
}

const t = buildTranslate('redeem_manager.modifier_select')

export const ModifierOrProductInput = (props: ModifierOrProductInputProps) => {
  const {
    name,
    label,
    secondaryText,
    tertiaryText,
    noteText,
    value,
    className = '',
    disabled = false,
    placeholder,
    setValue,
    toggleVisibility,
    hideLabel,
    onHide,
    shouldDisplayModifierPopover = false,
    popoverVariant,
    shouldDisplayInstoreValidationNote = false,
  } = props

  // Handle null/undefined values
  const selectedIds = value ?? []

  const toggleInputVisibility = () => {
    if (onHide) {
      onHide()
      return
    }
    setValue([])
    // Small delay to ensure Formsy propagates the change before unmounting
    setTimeout(() => {
      toggleVisibility?.(false)
    }, 0)
  }

  return (
    <div>
      <div className="d-flex flex-row justify-content-between">
        <div className="d-flex flex-row">
          <label id={name} className="body-text-4 bold mb-0">
            {label}
          </label>
          <Switch condition={shouldDisplayModifierPopover}>
            <ModifierPopover variant={popoverVariant} />
          </Switch>
        </div>
        <Switch condition={Boolean(toggleVisibility || onHide)}>
          <Button
            bsStyle="link"
            type="button"
            onClick={toggleInputVisibility}
            className="p-0 m-0"
          >
            {hideLabel ?? t('wrapper.hide')}
          </Button>
        </Switch>
      </div>

      <Switch condition={Boolean(secondaryText)}>
        <p className="mt-0 body-text-4 grey-70">{secondaryText}</p>
      </Switch>

      <Switch condition={Boolean(tertiaryText)}>
        <p className="mt-0 body-text-4 grey-70">{tertiaryText}</p>
      </Switch>

      <PillInput
        name={name}
        selectedIds={selectedIds}
        setValue={setValue}
        className={className}
        disabled={disabled}
        placeholder={placeholder}
      />

      <Switch condition={Boolean(noteText)}>
        <p className="mt-xs body-text-4 grey-70">{noteText}</p>
      </Switch>

      <Switch condition={Boolean(shouldDisplayInstoreValidationNote)}>
        <p className="mt-2 body-text-4 grey-70">
          <strong>{t('instore_validation_note.directive')}</strong>:{' '}
          {t('instore_validation_note.content')}
          <br />
          <a
            href={t('instore_validation_note.support_article_url')}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('instore_validation_note.learn_more')}
          </a>
        </p>
      </Switch>
    </div>
  )
}

export default withFormsy(ModifierOrProductInput)
